// ConnectionOverlay.js
// Aviso global de "sin conexión / reintentando" que setupAxios.js activa
// cuando una petición falla por red o timeout. Bloquea la pantalla mientras
// dura el reintento automático (pocos segundos) y, si sigue sin haber
// conexión, muestra un botón para reintentar a mano en vez de quedarse
// bloqueado de forma indefinida.
import React, { useEffect, useState } from "react";
import { subscribe, retryAll, dismiss } from "../api/connectionOverlay";

const ConnectionOverlay = () => {
  const [{ visible, phase }, setState] = useState({ visible: false, phase: "retrying" });

  useEffect(() => subscribe(setState), []);

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999,
      background: "rgba(15,23,42,0.55)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20,
    }}>
      <div style={{
        background: "#fff", borderRadius: 16, padding: "24px 26px",
        maxWidth: 320, width: "100%", textAlign: "center",
        boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
      }}>
        {phase === "retrying" ? (
          <>
            <div style={{
              width: 34, height: 34, margin: "0 auto 14px",
              border: "3.5px solid #e2e8f0", borderTopColor: "#1e293b",
              borderRadius: "50%", animation: "conn-overlay-spin 0.8s linear infinite",
            }} />
            <div style={{ fontWeight: 700, fontSize: 15, color: "#1e293b" }}>
              ⚠️ Error de conexión, reintentando…
            </div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 30, marginBottom: 10 }}>❌</div>
            <div style={{ fontWeight: 700, fontSize: 15, color: "#1e293b", marginBottom: 16 }}>
              Error de conexión de nuevo. Mejora tu conexión y vuelve a intentarlo.
            </div>
            <button
              onClick={() => retryAll()}
              style={{
                background: "#1e293b", color: "#fff", border: "none",
                borderRadius: 10, padding: "10px 22px", fontWeight: 700,
                fontSize: 14, cursor: "pointer",
              }}
            >
              Reintentar
            </button>
            <div>
              <button
                onClick={() => dismiss()}
                style={{
                  marginTop: 12, background: "none", border: "none",
                  color: "#94a3b8", fontSize: 12.5, cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                Seguir sin esperar
              </button>
            </div>
          </>
        )}
      </div>
      <style>{`@keyframes conn-overlay-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default ConnectionOverlay;
